import { render, staticRenderFns } from "./SimpleProfileSearch.vue?vue&type=template&id=34788fdf&"
import script from "./SimpleProfileSearch.vue?vue&type=script&lang=ts&"
export * from "./SimpleProfileSearch.vue?vue&type=script&lang=ts&"
import style0 from "./SimpleProfileSearch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports